"use client";

import { Icon } from "@iconify/react";
import predefineICons from "@/src/constants/icons";

interface AppIconInterface {
    icon: string;
    className?: string;
}

export default function AppIcon(props: AppIconInterface) {
    const { icon } = props;
    const icons:any = predefineICons;

    return (
        <Icon 
            {...props}
            icon={icons[icon]} 
        />
    )
}